import React from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import backArrow from "@src/assets/ico_arrow_back.png";
import { transferToNative } from "@src/lib/WebAppBridge";
import ItemADList from "./ui/ItemADList";
import RegionADList from "./ui/RegionADList";

const AdvertisementList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedParam = searchParams.get("selected");
    const selected = selectedParam === "region" ? "region" : "item";

    const handleSelect = (tab: "item" | "region") => {
        searchParams.set("selected", tab);
        setSearchParams(searchParams, { replace: true });
    };

    return (
        <Layout>
            <Header>
                <div
                    className="backBtn"
                    onClick={() => {
                        transferToNative("done", "closeWebView");
                    }}
                >
                    <img src={backArrow} alt="뒤로가기" />
                </div>
                <div className="title">매물/경매 지역광고 관리</div>
            </Header>

            <Content>
                <Selector>
                    <div className="selectorWrapper">
                        <div
                            className={`selectorItem ${selected === "item" ? "active" : ""}`}
                            onClick={() => handleSelect("item")}
                        >
                            매물광고
                        </div>
                        <div
                            className={`selectorItem ${selected === "region" ? "active" : ""}`}
                            onClick={() => handleSelect("region")}
                        >
                            경매 지역광고
                        </div>
                    </div>
                </Selector>

                {selected === "item" && <ItemADList />}
                {selected === "region" && <RegionADList />}
            </Content>
        </Layout>
    );
};

const Layout = styled.div`
    width: 100vw;
    height: 100vh;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 14px;

    .backBtn {
        position: absolute;
        left: 24px;
        width: 10px;
        height: 17px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0c002c;
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
    }
`;

const Selector = styled.div`
    width: 100%;
    padding: 0 14px;

    .selectorWrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 4px;

        border-radius: 10px;
        background-color: #fafafb;
    }

    .selectorItem {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;

        color: #0b1024;
        font-size: 15px;
        font-weight: 400;
        line-height: 22px;

        &.active {
            border-radius: 8px;
            background: #0064ff;

            color: #fff;
            font-size: 15px;
            font-weight: 700;
            line-height: 22px;
        }
    }
`;

export default AdvertisementList;
